import React from 'react'
import styled from '@emotion/styled'
import { spacer } from 'stylist'
import { ShadowedContainer } from 'components/Container'
import { GrowCol, CenteredCol } from 'components/Col'
import Vendor from 'components/Vendor'
import { commaify } from 'utils'

const SummaryWrapper = styled(ShadowedContainer)`
  .logo {
    margin-left: ${spacer(6)};
    margin-right: ${spacer(8)};
  }

  .col {
    margin-left: ${spacer(4)};

    &:not(:last-child) {
      flex: 1.7;
    }
  }
`

const Summary = ({ vendor, sampleSize, cpi }) => (
  <SummaryWrapper>
    <CenteredCol className="logo">
      <Vendor name={vendor.name} />
    </CenteredCol>
    <GrowCol className="col">
      <h5>Number of completes:</h5>
      <h6>{commaify(sampleSize)}</h6>
    </GrowCol>
    <GrowCol className="col">
      <h5>Cost per complete:</h5>
      <h6>${commaify(cpi.toFixed(2))}</h6>
    </GrowCol>
    <GrowCol className="col">
      <h5>Total:</h5>
      <h6>${commaify((sampleSize * cpi).toFixed(2))}</h6>
    </GrowCol>
  </SummaryWrapper>
)

export default Summary



// WEBPACK FOOTER //
// ./src/routes/purchase/summary.js